import { Link } from "react-router-dom";
import React from "react";

function ButtonBig(props) {
  return (
    <div className="btnBox">
      <Link to={props.dataLink}>{props.title}</Link>
    </div>
  );
}

function ButtonSmall(props) {
  const openModal = () => {
    document.querySelector(".modalWrap").classList.add("openModal");
  };

  return (
    <div className="btnBox">
      <Link to="/" onClick={openModal}>
        {props.leftTitle}
      </Link>

      <a
        href="https://www.16personalities.com/ko/무료-성격-유형-검사"
        target="_blank"
        rel="noopener noreferrer"
        className="black"
      >
       검사하기
      </a>
    </div>
  );
}

export { ButtonBig, ButtonSmall };
